import { extendServiceContainer } from '@iotize/tap';
import { LteService } from './service';

declare module '@iotize/tap/lib/service-container' {
  interface ServiceContainer {
    lte: LteService;
  }
}

export const _TAP_SERVICE_EXTENSION_LTE_ = extendServiceContainer(
  'lte',
  LteService,
);
